import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Message from '../Message'
import styles from './styles.module.scss'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import Spinner from 'srcReact/components/common2/Spinner'
import { messengerActions } from 'srcReact/MessengerPage'
import { commonActions, PopinComponent } from 'srcReact/components'
import DeleteMessageConfirmation from '../DeleteMessageConfirmation'
import SayHi from '../SayHi'
import {
  convertToLocalDate,
  formatLastUpdateDate,
  getDateFormat2,
  getTime,
  isTimeDiffLessThan12h,
  isTimeDiffLessThanMinute
} from 'srcReact/helpers/datetimeHelper'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import FileNavigationPopup from 'srcReact/components/common2/FileNavigationPopup'
import { messengerSettings } from 'srcReact/MessengerPage/MessengerSettings'
import useInterval from 'srcReact/helpers/hooks/useInterval'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import PendingMessageCount from 'srcReact/components/common2/FeedsTabContent/components/PendingMessageCount'

export default function ChatWindow({ isMobile, isDesktop, isNative, setIsFileModalOpen, targetRefs, scrollToTarget, fromQuickMessenger }) {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    messenger: {
      openedConversation,
      originMessage,
      isMessagePosted,
      loadingSendMessage,
      openedFromLightProfile,
      loadingFileDeletion,
      pendingMessages,
      scrollToMessage,
      messageTags
    },
    login: { user: loggedInUser }
  } = useSelector((state) => state)
  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const [messageToDelete, setMessageToDelete] = useState(null)
  const [showFilePopup, setShowFilePopup] = useState(false)
  const [currentFile, setCurrenFile] = useState(null)
  const [currentFileIndex, setCurrenFileIndex] = useState(-1)
  const [currentMessageId, setCurrentMessageId] = useState(null)
  const [files, setFiles] = useState([])
  const [showScrollButton, setShowScrollButton] = useState(false)
  const containerRef = useRef(null)
  const [editModeMessage, setEditModeMessage] = useState(null)
  const [emojiForMessage, setEmojiForMessage] = useState(null)
  const [selectedMessage, setSelectedMessage] = useState(null)
  const [pendingMessageCount, setPendingMessageCount] = useState(0)

  useEffect(() => {
    if (isMessagePosted || loadingSendMessage) {
      scrollToLatest()
    }
  }, [isMessagePosted, loadingSendMessage])
  useEffect(() => {
    if (scrollToMessage.conversation_id > 0 && scrollToMessage.content_offset > 0 && scrollToMessage.message_id > 0) {
      setPagination({ nextOffset: scrollToMessage.content_offset, isPagination: true })
    }
  }, [scrollToMessage])
  useEffect(() => {
    if (openedConversation.conversation.id > 0 && pagination.isPagination) {
      dispatch(
        messengerActions.getConversationOpenPagination(openedConversation.conversation.id, pagination.nextOffset)
      )
    }
  }, [pagination])
  useEffect(() => {
    setTimeout(() => {
      if (openedConversation.conversation.id > 0 && messageTags.tags.length > 0) {
        if (pendingMessages.length === 0) {
          setPendingMessageCount(messageTags.tags.length)
        } else {
          setPendingMessageCount(0)
        }
      }
    }, 500)

    return () => {
      setPendingMessageCount(0)
    }
  }, [openedConversation.conversation.id, messageTags.tags])

  // Get realtime updates
  useInterval(() => {
    if (
      openedConversation.conversation.id > 0 &&
      openedConversation.conversation.isLeftByUser === 0 &&
      openedConversation.conversation.hasBeenRemoved === 0 &&
      openedConversation.loaded &&
      !openedConversation.loading &&
      !loadingSendMessage
    ) {
      dispatch(messengerActions.openConversationCheckUpdates(openedConversation.conversation.id))
    }
  }, messengerSettings.REFRESH_INTERVAL)

  const unsetEditMode = () => {
    setEditModeMessage(null)
  }
  const setEditMode = (message) => {
    setEditModeMessage(message)
  }
  const unsetEmojiPickerForMessage = () => {
    setEmojiForMessage(null)
  }
  const setEmojiPickerForMessage = (message) => {
    setEmojiForMessage(message)
  }
  const deleteMessagePopin = (message) => {
    dispatch(commonActions.openPopin('delete-message-confirm'))
    setMessageToDelete(message)
  }
  const showImageModal = (file, fileIndex, files, isFileOwner, messageId) => {
    setShowFilePopup(true)
    setCurrenFile(file)
    setFiles(files)
    setCurrenFileIndex(fileIndex)
    setCurrentMessageId(messageId)
    if (setIsFileModalOpen) {
      setIsFileModalOpen(true)
    }
  }
  const closeImageModal = () => {
    setShowFilePopup(false)
    setCurrenFile(null)
    setFiles([])
    setCurrenFileIndex(-1)
    setCurrentMessageId(null)
    if (setIsFileModalOpen) {
      setIsFileModalOpen(false)
    }
  }
  const showUserModal = (user, index) => {
    if (!openedFromLightProfile) {
      const lp = new LightProfileProto()
      lp.userId = user.id
      lp.fromMessenger = true
      // lp.showSendMessage =
      //   checkNested(openedConversation, 'active_users') &&
      //   openedConversation.active_users.length >= 3 &&
      //   user.id !== loggedInUser.id
      //     ? true
      //     : false

      dispatch(lightProfileActions.openLightProfileModal(lp))
    }
  }

  const lastMessageRef = useInfinitScroll(
    openedConversation.loading,
    openedConversation.content.stat.remaining,
    openedConversation.content.stat.nextOffset,
    setPagination,
    [openedConversation.loading]
  )
  const observer = useRef()
  const firstMessageRef = useCallback(
    (node) => {
      if (observer.current) {
        observer.current.disconnect()
      }
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setShowScrollButton(false)
        } else {
          setShowScrollButton(true)
        }
      })
      if (node) {
        observer.current.observe(node)
      }
    },
    [observer]
  )
  const getDividerDate = (message, currentDate, nextDate) => {
    const currentCreatedUTC = message.id ? convertToLocalDate(currentDate) : currentDate
    const currentCreatedAtDateStr = formatLastUpdateDate(currentCreatedUTC, getDateFormat2(), t)

    const nextCreatedUTC = message.id && nextDate ? convertToLocalDate(nextDate) : nextDate
    const nextCreatedDateStr = nextCreatedUTC && formatLastUpdateDate(nextCreatedUTC, getDateFormat2(), t)

    const todayDate = new Date()
    const todayDateStr = formatLastUpdateDate(todayDate, getDateFormat2(), t)
    const yesterdayDate = new Date()
    yesterdayDate.setDate(yesterdayDate.getDate() - 1)
    const yesterdayDateStr = formatLastUpdateDate(yesterdayDate, getDateFormat2(), t)

    if (currentCreatedAtDateStr !== nextCreatedDateStr) {
      if (!nextDate) {
        return todayDateStr === currentCreatedAtDateStr
          ? t('messenger.today')
          : yesterdayDateStr === currentCreatedAtDateStr
          ? t('messenger.yesterday')
          : currentCreatedAtDateStr
      }

      if (todayDateStr === currentCreatedAtDateStr) {
        return t('messenger.today')
      } else if (yesterdayDateStr === currentCreatedAtDateStr) {
        return t('messenger.yesterday')
      } else return currentCreatedAtDateStr
    }
    return ''
  }
  const scrollToLatest = () => {
    containerRef.current.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
  const getRemovedBy = () => {
    let removedByName = ''
    if (openedConversation) {
      const { active_users, inactive_users } = openedConversation
      const removedUser = inactive_users.find((u) => u.id === loggedInUser.id)
      const removedByUser = removedUser && active_users.find((u) => u.id === removedUser.removedBy)
      removedByName = removedByUser ? `${removedByUser.firstname} ${removedByUser.lastname}` : ''
    }
    return removedByName
  }
  const messageList = openedConversation && openedConversation.content && openedConversation.content.messages

  const isFileProcessingForMessage = (message) => {
    return message.tag?.length > 0
  }

  return (
    <React.Fragment>
      {/** In this div, added transform: scaleY(-1) for native views to fix message options animation. Therefore, any new divs that we add need to have the isNativeView class */}
      <div
        id='chatWindow'
        ref={containerRef}
        // onScroll={onScroll}
        className={`${styles.container} ${originMessage && styles.containerWithReplyOpen} ${
          isNative && styles.isNativeContainer
        }`}>
        <div>
          {openedConversation && openedConversation.conversation.isLeftByUser === 1 && (
            <div className={styles.noParticipantError}>{t('messenger.leftConvErrorMessage')}</div>
          )}

          {openedConversation && openedConversation.conversation.hasBeenRemoved === 1 && (
            <div className={styles.noParticipantError}>
              {t('messenger.removedFromConvErrorMessage', { removedBy: getRemovedBy() })}
            </div>
          )}
          {((openedConversation && openedConversation.conversation.isLeftByUser === 1) ||
            openedConversation.conversation.hasBeenRemoved === 1) && (
            <div className={styles.inactiveMemberError}>{t('messenger.inactiveMemberErrorMessage')}</div>
          )}
        </div>

        {/* {messageWithFileInProgress.length > 0 && (
          <p className={`${styles.loadingFileMessage} ${isNative && styles.isNativeView}`}>
            {messageWithFileInProgress}
            <Spinner customCss={styles.loader} />
          </p>
        )} */}
        {pendingMessageCount > 0 && <PendingMessageCount from={'messenger'} count={pendingMessageCount} />}

        {pendingMessages?.length > 0 &&
          pendingMessages.map((message) => {
            if (message.parentObjectId === openedConversation.conversation.id) {
              return (
                <div className={isNative && styles.isNativeView}>
                  <Message
                    key={message.messageId}
                    messageProp={message}
                    user={loggedInUser}
                    showImageModal={showImageModal}
                    isMobile={isMobile}
                    isDesktop={isDesktop}
                    isSender={true}
                    id_user={loggedInUser.id}
                    isFileProcessing={isFileProcessingForMessage(message)}
                    targetRefs={targetRefs}
                    scrollToTarget={scrollToTarget}
                    fromQuickMessenger={fromQuickMessenger}
                  />
                </div>
              )
            }
          })}

        {openedConversation &&
          messageList &&
          messageList.length >= 1 &&
          messageList.map((message, index) => {
            if (message.id || message.tempId) {
              let user = openedConversation.active_users.find((u) => {
                return u.id === message.id_user
              })

              if (!user) {
                user = openedConversation.inactive_users.find((u) => {
                  return u.id === message.id_user
                })
              }

              const isFirstMessage = index === 0
              const isLastMessage = index === messageList.length - 4 // when last 3rd message is visible, load more messages(infinite scrolling)

              const appendToPrevious =
                index <= messageList.length - 2 &&
                messageList[index + 1].id_user === messageList[index].id_user &&
                !messageList[index + 1].origin_message &&
                isTimeDiffLessThan12h(messageList[index + 1].createdAt, messageList[index].createdAt)
                  ? true
                  : false

              const showTime =
                index <= messageList.length - 2 &&
                isTimeDiffLessThanMinute(messageList[index + 1].createdAt, messageList[index].createdAt)
                  ? false
                  : true

              const dateForDivider = getDividerDate(
                messageList[index],
                messageList[index].createdAt,
                index <= messageList.length - 2 && messageList[index + 1].createdAt
              )
              const isMessageDeleted = message.has_been_deleted === 1
              let messageDateTime = message.createdAt
              if (isMessageDeleted) {
                messageDateTime = message.deletedAt
              }

              let localDate = convertToLocalDate(messageDateTime)
              if (message.tempId && !message.id) {
                localDate = message.createdAt
              }

              const messageTime = getTime(localDate)

              return (
                <div className={isNative && styles.isNativeView}>
                  {dateForDivider && (
                    <Divider date={dateForDivider} isMobile={isMobile} message={message} loggedInUser={loggedInUser} />
                  )}
                  <Message
                    key={message.id}
                    messageProp={message}
                    user={user}
                    appendToPrevious={appendToPrevious && !dateForDivider}
                    lastMessageRef={lastMessageRef}
                    isLastMessage={isLastMessage}
                    firstMessageRef={firstMessageRef}
                    isFirstMessage={isFirstMessage}
                    deleteMessagePopin={deleteMessagePopin}
                    showUserModal={showUserModal}
                    showImageModal={showImageModal}
                    setEditMode={setEditMode}
                    unsetEditMode={unsetEditMode}
                    editModeMessage={editModeMessage}
                    emojiPickerForMessage={emojiForMessage}
                    setEmojiPickerForMessage={setEmojiPickerForMessage}
                    unsetEmojiPickerForMessage={unsetEmojiPickerForMessage}
                    showTime={showTime}
                    messageTime={messageTime}
                    isMobile={isMobile}
                    isDesktop={isDesktop}
                    isSender={message.id_user === loggedInUser.id}
                    selectedMessage={selectedMessage}
                    setSelectedMessage={setSelectedMessage}
                    targetRefs={targetRefs}
                    scrollToTarget={scrollToTarget}
                    fromQuickMessenger={fromQuickMessenger}
                  />
                </div>
              )
            }
          })}

        {openedConversation.conversation.isLeftByUser === 0 &&
          openedConversation.conversation.hasBeenRemoved === 0 &&
          !openedConversation.loading &&
          openedConversation.loaded &&
          messageList &&
          messageList.length === 0 && <SayHi isNative={isNative} />}

        {openedConversation.loading && !openedConversation.loaded && <Spinner />}
      </div>

      {messageToDelete && (
        <PopinComponent name='delete-message-confirm'>
          <DeleteMessageConfirmation message={messageToDelete} isNative={isNative} />
        </PopinComponent>
      )}

      {showFilePopup && currentFile && (
        <FileNavigationPopup
          isOpen={showFilePopup}
          file={currentFile}
          fileIndex={currentFileIndex}
          files={files}
          loggedInUserId={loggedInUser.id}
          closeModal={closeImageModal}
          enableDeleteFile={false}
          openedConversation={openedConversation}
          loadingFileDeletion={loadingFileDeletion}
        />
      )}

      {showScrollButton && (
        <div
          role='button'
          aria-label={t('messenger.scrollToLatest')}
          className={styles.scrollToLatestBtn}
          onClick={scrollToLatest}>
          <Icon styleModifier={styles.scrollToLatestIcon} name='chevron-down' alt={t('messenger.scrollToLatest')} />
        </div>
      )}
    </React.Fragment>
  )
}

function Divider({ date, isMobile, message, loggedInUser }) {
  const isSender = message.id_user === loggedInUser.id ? true : false

  return <div className={`${styles.divider}  ${isSender && styles.isSender} `}>{date}</div>
}
